import { Alert, Typography } from '@mui/material';
import { type FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../store';
import { dismissBannerAlert } from '../../reducers';

const selector = ({ alert }: RootState) => alert;

const AlertBanner: FC = () => {
  const dispatch = useDispatch();
  const { bannerAlert } = useSelector(selector);

  const dismiss = useCallback(() => {
    dispatch(dismissBannerAlert());
  }, [dispatch]);

  if (bannerAlert === null) {
    return null;
  }

  return (
    <Alert
      icon={false}
      severity={bannerAlert.severity}
      sx={{ justifyContent: 'center', '& .MuiAlert-message': { flex: 1 } }}
      onClose={dismiss}
    >
      <Typography variant="body2" textAlign="center">
        {bannerAlert.message}
      </Typography>
    </Alert>
  );
};

export { AlertBanner };
